(() => {
	'use strict';

	if (customElements.get('related-products')) return;

	customElements.define(
		'related-products',
		class extends HTMLElement {
			connectedCallback() {
				this.loadRelatedProducts();
				this.loadRecentlyViewedProducts();
			}

			isMobileCarouselEnabled() {
				const layout = this.getAttribute('data-layout');
				const layoutMobile = this.getAttribute('data-layout-mobile');
				return layout === 'grid' && layoutMobile === 'carousel';
			}

			applyMobileCarouselLayout(scope) {
				if (!scope || !this.isMobileCarouselEnabled()) return;

				scope.querySelectorAll('.grid--mobile').forEach((element) => {
					element.classList.remove('grid--mobile');
					element.classList.add('carousel--mobile');
				});
			}

			loadRelatedProducts() {
				this.relatedProducts = this.querySelector('[data-related-products]');
				if (!this.relatedProducts) return;

				const sectionId = this.getAttribute('data-section-id');
				const productId = this.getAttribute('data-product-id');
				const limit = this.getAttribute('data-limit');
				const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

				fetch(requestUrl)
					.then((response) => {
						if (!response.ok) {
							this.hideRelated();
							throw new Error(response.status);
						}

						return response.text();
					})
					.then((markup) => {
						const container = document.createElement('div');
						container.innerHTML = markup;

						const productsMarkup = container.querySelector('[data-related-products]');
						if (!productsMarkup || !productsMarkup.querySelectorAll('[data-product-block]').length) return;

						this.relatedProducts.innerHTML = productsMarkup.innerHTML;
						this.applyMobileCarouselLayout(this.relatedProducts);
					});
			}

			loadRecentlyViewedProducts() {
				this.recentlyViewed = this.querySelector('recently-viewed');

				if (!this.recentlyViewed) return;

				this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
					this.handleRecentlyViewedResponse();
				});
			}

			handleRecentlyViewedResponse() {
				this.applyMobileCarouselLayout(this.recentlyViewed);

				const recentlyViewedWrapper = this.recentlyViewed.closest('[data-recently-viewed-wrapper]');
				const products = this.recentlyViewed.querySelectorAll('[data-product-block]');
				const animatedElements = this.recentlyViewed.querySelectorAll('[data-aos]');
				const slider = this.recentlyViewed.querySelector('grid-slider');
				const minimum = this.recentlyViewed.hasAttribute('data-minimum') ? parseInt(this.recentlyViewed.getAttribute('data-minimum'), 10) : 1;
				const hasProducts = !recentlyViewedWrapper && products.length > 0;
				const hasEnoughProducts = recentlyViewedWrapper && products.length >= minimum;
				const columnsMobile = slider?.getAttribute('data-column-mobile');

				if (!(hasProducts || hasEnoughProducts)) return;

				if (hasEnoughProducts) {
					this.classList.remove('hidden');
				}

				if (slider) {
					requestAnimationFrame(() => {
						slider.dispatchEvent(new CustomEvent('theme:slider:resize', {bubbles: true}));
					});

					slider.querySelectorAll('[data-slide]').forEach((slide) => {
						if (columnsMobile == 2) {
							slide.classList.add('mobile--one-half');
							slide.classList.remove('mobile--one-whole');
						} else {
							slide.classList.add('mobile--one-whole');
							slide.classList.remove('mobile--one-half');
						}
					});
				}

				const shownAnimations = [];
				this.recentlyViewed.addEventListener('theme:target:animate', (event) => {
					shownAnimations.push(event.detail);

					if (shownAnimations.length !== animatedElements.length) return;

					requestAnimationFrame(() => {
						animatedElements.forEach((element) => element.classList.add('aos-animate'));
					});
				});
			}

			hideRelated() {
				const tab = this.relatedProducts.closest('[data-tab]');
				const tabsHolder = this.relatedProducts.closest('[data-tabs-holder]');
				const tabsLink = tabsHolder?.querySelector(`[data-tabs-link="${tab.dataset.tab}"]`);

				tab?.remove();

				if (tabsLink) {
					tabsLink.remove();
					tabsHolder.querySelector('[data-tabs-link]')?.dispatchEvent(new Event('click'));
				}
			}
		}
	);
})();
